import React, { useState, useEffect } from "react";
import { DivTag } from "../../../Components/Tags/Tags";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { HeadTag, InputField } from "../../../Components/Tags/Tags";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import GaugeChart from "react-gauge-chart";
import {
  checkCrifCreditScore4,
  V2VerifyMobile,
} from "../../../Services/EquifaxCScore/highmark";
import CrifScoreReportModal from "./CrifScoreReport4";
import html2pdf from "html2pdf.js";
// import { CrifCreditScoredata, EV2MobileVerify } from "./data";
import Loader from "../../../Loader";
import { fetchProfile } from "../../../Services/profile/profileservice";
import { FaHandPointLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import { getServiceNameAndDetails } from "../../../Services";

const CrifCreditScore4 = () => {
  const endPoint = "/crif/Credit-ScoreV4";
  const [serviceName, setServiceName] = useState("");

  const [cusName, setCusName] = useState();
  const [mobile, setMobile] = useState("");
  const [panNo, setPanNo] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);
  const [docType, setDocType] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [profileData, setProfileData] = useState([]);
  const [crifV4Report, setCrifV4Report] = useState(null); // Put null i no
  const [crifV4Error, setCrifV4Error] = useState(null); // Put Null if no
  // const [creditScore, setCreditScore] = useState(CrifCreditScoredata?.data?.credit_report?.SCORES?.SCORE?.['SCORE-VALUE'] );
  const [creditScore, setCreditScore] = useState(0);
  const [submittedName, setSubmittedName] = useState("");
  const [submittedMobile, setSubmittedMobile] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [isModalOpenMobile, setIsModalOpenMobile] = useState(false);
  const [mobileResponseData, setMobileResponseData] = useState(null);
  const [afterVerifyMobPan, setAfterVerifyMobPan] = useState("");
  const [afterVerifyMobAadhar, setAfterVerifyMobAadhaar] = useState("");
  const [afterMobName, setAfterMobName] = useState("");
  const [triggerVerifyContine, setTriggerVerifyContinue] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [isVerifyDisabled, setIsVerifyDisabled] = useState(
    sessionStorage.getItem("verifyClicked") === "true",
  );

  const maxScore = 900;
  const validateForm = () => {
    const newErrors = {};

    if (!firstName.trim()) {
      newErrors.firstName = "First Name is required.";
    }

    if (!lastName.trim()) {
      newErrors.lastName = "Last Name is required.";
    }

    // Validate mobile
    if (mobile === "") {
      newErrors.mobile = "Mobile number is required.";
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
    }

    if (panNo === "") {
      newErrors.panNo = "PAN number is required.";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNo.toUpperCase().trim())) {
      newErrors.panNo = "Enter a valid PAN number (e.g., ABCDE1234F).";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlesubmit = async () => {
    try {
      // Validate the form first
      const isValid = validateForm();
      if (!isValid) {
        setCrifV4Report(null);
        setCrifV4Error(null);
        return;
      }
      setShowLoader(true);
      await GetCrifCreditScore();

      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
    } catch (error) {
      console.error("Error submitting data:", error);
      showErrorToast("Validate the Required Field");
      setShowLoader(false);
    }
  };

  const handleDownloadPDF = () => {
    setIsDownloading(true);
    setTimeout(() => {
      const element = document.getElementById("CreditReport");

      if (element) {
        element.classList.remove("hidden");
        const clonedElement = element.cloneNode(true);
        clonedElement.style.maxHeight = "none";
        clonedElement.style.overflow = "visible";
        const tempDiv = document.createElement("div");
        tempDiv.style.position = "absolute";
        tempDiv.style.visibility = "hidden";
        tempDiv.appendChild(clonedElement);
        document.body.appendChild(tempDiv);
        html2pdf()
          .from(clonedElement)
          .set({
            margin: [0.2, 0.2, 0.2, 0.2],
            filename: "Crif Credit Report.pdf",
            image: { type: "jpeg", quality: 0.9 },
            html2canvas: { scale: 2, backgroundColor: "white" },
            jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
          })
          .save()
          .then(() => {
            document.body.removeChild(tempDiv);
            element.classList.add("hidden");
            setIsDownloading(false); //  Stop loading
          })
          .catch(() => {
            showErrorToast("Failed to generate PDF");
            element.classList.add("hidden");
            setIsDownloading(false); //  Stop loading
          });
      } else {
        showErrorToast("No data found to download");
      }
    }, 500);
  };

  async function GetCrifCreditScore() {
    try {
      setShowLoader(true);
      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_no: mobile,
        pan: panNo,
        first_name: firstName,
        last_name: lastName,
        name_lookup: 0,
       
      };
      const response = await checkCrifCreditScore4(payload);
      const statusCode = response?.status?.code || response?.status || response?.data?.status?.code;

      if(response){
        console.log(response);
      }

      if (
        statusCode === 403 &&
        statusCode.message === "Invalid or deactivated API key."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return;
      }

      if (
        statusCode === 422 &&
        statusCode.message === "Insufficient balance in wallet."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance.");
        return;
      }

      if (
        statusCode === 422 &&
        statusCode.message ===
          "Your service is not available in this environment."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Your service is not available in this environment.");
        return;
      }

      if (
        statusCode === 422 &&
        statusCode.message === "User not authorized to access this service."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");
        return;
      }
      console.log(
        "res",
        response?.data?.report_data?.crifData?.SCORES?.SCORE?.["SCORE-VALUE"] ||
          0,
      );

      if (statusCode === 200) {
        //  Success

        setCrifV4Report(response || response?.data);
        setCreditScore(
          Number(
            response?.data?.report_data?.crifData?.SCORES?.SCORE?.[
              "SCORE-VALUE"
            ] ||
              response?.data?.report_data?.["REPORT-DATA"]?.["STANDARD-DATA"]
                ?.SCORE?.[0]?.VALUE ||
              0,
          ),
        );

        setSubmittedName(cusName);
        setCusName("");
        setMobile("");
        setPanNo("");
        setFirstName("")
        setLastName("")
        showSuccessToast(
          response?.credit_report_message?.message ||
            response?.message ||
            "Credit score fetched successfully.",
        );
      } else {
        //  All other errors
        setCrifV4Error(response?.error || response?.data || {}); // Now capturing error block
        setCrifV4Report(null);
        // setModalOpen(true);
        showErrorToast(
          response?.data?.message || // Fallback message in response.data
            response?.message || // Type 1 error (top-level message)
            response?.data?.error?.credit_report_message?.message || // Type 2 error
            response?.data?.error || // Direct string error like "Insufficient balance.
            "Something went wrong.", // Default fallback
        );
      }
    } catch (error) {
      console.error("Error in Crif Score:", error);
      setCrifV4Report(null);
      setCrifV4Error(error);
      showErrorToast("Something went wrong.");
    } finally {
      setShowLoader(false);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    async function fetchProfileData() {
      try {
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data", error);
      }
    }
    fetchProfileData();
  }, []);

  const handleVerifyMobile = async () => {
    const newErrors = {};

    // Only validate mobile
    if (!mobile.trim()) {
      newErrors.mobile = "Mobile is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setShowLoader(true);
      setIsVerifyDisabled(true);
      sessionStorage.setItem("verifyClicked", "true");

      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_number: mobile,
        first_name: firstName,
        last_name: lastName,
      };

      const response = await V2VerifyMobile(payload);

      if (
        response.status === 403 &&
        response.data.message === "Invalid or deactivated API key."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return;
      }

      if (
        response.status === 422 &&
        response.data.message === "Insufficient balance in wallet."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance in wallet.");
        return;
      }

      if (
        response.status === 422 &&
        response.data.message === "User not authorized to access this service."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");

        return;
      }

      setMobileResponseData(response || response?.data || response?.data?.data);
      if (response?.data?.result !== null) {
        showSuccessToast(
          response?.status?.message ||
            response?.message ||
            "Consumer Details Fetched",
        );
      } else {
        showErrorToast(
          response?.status?.message || response?.message || "No Records Found",
        );
      }

      setShowLoader(false);
      setIsLoading(false);
      setIsModalOpenMobile(true);
      setIsVerifyDisabled(false);
    } catch (error) {
      console.error("Error verifying Consumer:", error);
      setIsVerifyDisabled(false);
      setShowLoader(false);
      setIsLoading(false);
    }
  };

  // Reset on page load
  useEffect(() => {
    sessionStorage.removeItem("verifyClicked");
  }, []);

  const VerifyContinue = () => {
    setTriggerVerifyContinue(true);
    setIsModalOpenMobile(false);
  };

  useEffect(() => {
    if (triggerVerifyContine) {
      // Priority: PAN first, then Aadhaar
      if (afterVerifyMobPan && !afterVerifyMobPan.startsWith("XXXX")) {
        setDocType("pan");
        setPanNo(afterVerifyMobPan);
      } else if (
        afterVerifyMobAadhar &&
        !afterVerifyMobAadhar.startsWith("XXXX")
      ) {
        setDocType("aadhaar");
        setPanNo(afterVerifyMobAadhar);
      }

      if (afterMobName) {
        const name = afterMobName || "";
        const nameParts = name.trim().split(" ");
        const firstNameFromName = nameParts[0] || "";
        const lastNameFromName =
          nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";

        setFirstName(firstNameFromName);
        setLastName(lastNameFromName);

        //  setCusName(afterMobName);
      }

      // Reset trigger
      setTriggerVerifyContinue(false);
    }
  }, [
    triggerVerifyContine,
    afterVerifyMobPan,
    afterVerifyMobAadhar,
    afterMobName,
  ]);

  // useEffect(() => {

  //   console.log("score", Equifaxv2Report?.data?.report_data?.["REPORT-DATA"]?.["STANDARD-DATA"]?.SCORE?.[0]?.VALUE);

  // }, [creditScore, Equifaxv2Report])

  const accSummary =
    crifV4Report?.report_data?.crifData?.["ACCOUNTS-SUMMARY"] ||
    crifV4Report?.data?.report_data?.["REPORT-DATA"]?.["ACCOUNTS-SUMMARY"] ||
    crifV4Report?.data?.report_data?.crifData?.["ACCOUNTS-SUMMARY"] ||
    crifV4Report?.data?.credit_report?.["ACCOUNTS-SUMMARY"] ||
    crifV4Report?.data?.result_json?.credit_report?.["account_summary"] ||
    {};
  const primary = accSummary["primary_accounts_summary"] || {};
  const derived = accSummary["derived_attributes"] || {};

  useEffect(() => {
    const getServiceName = async () => {
      try {
        const res = await getServiceNameAndDetails({
          end_point: endPoint,
        });

        if (res?.status?.code === 200) {
          setServiceName(res?.data?.service_name);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getServiceName();
  }, []);

  return (
    <>
      <Seo />
      {showLoader && <Loader />}

      <Header heading={serviceName || "Crif Credit Score V4"} />
      <DivTag className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 p-6 bg-white rounded-xl border border-slate-100 shadow-sm">
        {/* First Name */}
        <DivTag className="flex flex-col">
          <HeadTag className="text-sm font-medium text-slate-700 mb-1.5">
            First Name
            <span className="text-destructive text-red-500 ml-0.5">*</span>
          </HeadTag>
          <input
            type="text"
            id="first_name"
            name="first_name"
            value={firstName}
            className="w-full px-3.5 py-2 text-sm text-slate-900 bg-white border border-slate-400 rounded-lg placeholder:text-slate-600 focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-50 transition-all duration-200"
            placeholder="Enter First Name"
            onChange={(e) => {
              setFirstName(e.target.value);
              setErrors((prev) => ({ ...prev, firstName: "" }));
            }}
          />
          {errors.firstName && (
            <p className="text-xs text-red-500 font-medium mt-1.5 transition-all">
              {errors.firstName}
            </p>
          )}
        </DivTag>

        {/* Last Name */}
        <DivTag className="flex flex-col">
          <HeadTag className="text-sm font-medium text-slate-700 mb-1.5">
            Last Name<span className="text-red-500 ml-0.5">*</span>
          </HeadTag>
          <input
            type="text"
            id="last_name"
            name="last_name"
            value={lastName}
            className="w-full px-3.5 py-2 text-sm text-slate-900 bg-white border border-slate-400 rounded-lg placeholder:text-slate-600 focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-50 transition-all duration-200"
            placeholder="Enter Last Name"
            onChange={(e) => {
              setLastName(e.target.value);
              setErrors((prev) => ({ ...prev, lastName: "" }));
            }}
          />
          {errors.lastName && (
            <p className="text-xs text-red-500 font-medium mt-1.5 transition-all">
              {errors.lastName}
            </p>
          )}
        </DivTag>

        {/* Mobile */}
        <DivTag className="flex flex-col">
          <div className="flex items-center justify-between mb-1.5">
            <HeadTag className="text-sm font-medium text-slate-700">
              Mobile <span className="text-red-500 ml-0.5">*</span>
            </HeadTag>

            {/* Styled inline action button if ever uncommented */}
            {/* <button
        type="button"
        onClick={() => setIsModalOpenMobile(true)}
        className="text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors"
      >
        View
      </button> */}
          </div>

          <div className="flex gap-2">
            <InputField
              type="text"
              value={mobile}
              placeholder="Enter Mobile"
              className="w-full px-3.5 py-2 text-sm text-slate-900 bg-white border border-slate-400 rounded-lg placeholder:text-slate-600 focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-50 transition-all duration-200"
              name="mobile"
              id="mobile"
              onChange={(e) => setMobile(e.target.value)}
            />
            {/* Styled verification button if ever uncommented */}
            {/* <button
        type="button"
        onClick={handleVerifyMobile}
        disabled={isVerifyDisabled}
        className={`px-3.5 py-2 text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 shadow-sm transition-all duration-200 ${isVerifyDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        Verify
      </button> */}
          </div>

          {errors.mobile && (
            <p className="text-xs text-red-500 font-medium mt-1.5 transition-all">
              {errors.mobile}
            </p>
          )}

          {isModalOpenMobile && (
            <MobileDataModal
              setAfterMobName={setAfterMobName}
              mobileResponseData={mobileResponseData}
              setAfterVerifyMobPan={setAfterVerifyMobPan}
              setAfterVerifyMobAadhaar={setAfterVerifyMobAadhaar}
              VerifyContinue={VerifyContinue}
              onClose={() => setIsModalOpenMobile(false)}
            />
          )}
        </DivTag>

        {/* Doc No. */}
        <DivTag className="flex flex-col">
          <HeadTag className="text-sm font-medium text-slate-700 mb-1.5">
            PAN No.
            <span className="text-red-500 ml-0.5">*</span>
          </HeadTag>

          <InputField
            type="text"
            placeholder={"Enter PAN"}
            className="w-full px-3.5 py-2 text-sm text-slate-900 bg-white border border-slate-400 rounded-lg placeholder:text-slate-600 focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-50 transition-all duration-200 disabled:bg-slate-50 disabled:text-slate-400 disabled:cursor-not-allowed"
            name="pan_no"
            id="pan_no"
            value={panNo}
            onChange={(e) => setPanNo(e.target.value)}
            disabled={!docType}
          />
          {errors.panNo && (
            <p className="text-xs text-red-500 font-medium mt-1.5 transition-all">
              {errors.panNo}
            </p>
          )}
        </DivTag>
      </DivTag>

      <div className="flex justify-center w-full mt-6 mb-2">
        <button
          type="button"
          onClick={handlesubmit}
          disabled={isLoading || !panNo || !firstName || !lastName || !mobile}
          className={`
      inline-flex items-center justify-center 
      px-6 py-2.5 disabled:opacity-45
      text-sm font-semibold text-white 
      bg-blue-600 hover:bg-blue-700 
      rounded-lg shadow-sm
      focus:outline-none focus:ring-4 focus:ring-blue-100
      transition-all duration-200 ease-in-out
      ${isLoading ? "opacity-75 cursor-not-allowed" : "active:scale-[0.98]"}
    `}
        >
          {isLoading ? (
            <>
              {/* Modern Minimalistic Spinner */}
              <svg
                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              Submitting...
            </>
          ) : (
            "Get Credit Report"
          )}
        </button>
      </div>

      <div className="w-full text-center">
        {errors.identification && (
          <p className="text-red-600 text-sm font-mono">
            {errors.identification}
          </p>
        )}
      </div>

      {crifV4Report || crifV4Error ? (
        <div className="flex flex-col mb-6 p-6 md:p-8 bg-white border border-slate-100 shadow-xl shadow-slate-200/50 rounded-2xl md:mt-4 w-full">
          {/* Greeting & Header Segment */}
          <div className="text-center mb-6">
            {(() => {
              const message =
                crifV4Error?.error?.credit_report_message?.message ||
                crifV4Error?.message ||
                crifV4Report?.status?.message ||
                "";

              const isSuccess = message?.toLowerCase().includes("success");

              if (isSuccess) return null;

              const formatText = (text) =>
                text
                  ?.replace(/_/g, " ")
                  .replace(/\b\w/g, (c) => c.toUpperCase());

              return (
                <>
                  {message?.length > 0 && (
                    <div className="flex flex-col items-center justify-center my-5">
                      <div className="bg-red-50 border border-red-400 rounded-md p-1 w-full md:w-3/4">
                        <p className="text-center text-black font-bold">
                          Error:{" "}
                          <span className="font-normal">
                            {formatText(message)}
                          </span>
                        </p>
                      </div>
                    </div>
                  )}
                </>
              );
            })()}
            <p className="text-sm font-medium text-slate-400 uppercase tracking-wider mb-1">
              Credit Assessment
            </p>
            <h2 className="text-xl md:text-2xl font-bold text-slate-900">
              Hey,{" "}
              {crifV4Report?.data?.result_json?.credit_report?.customer_identity?.name ||
                    "User"}
              !
            </h2>
          </div>

          {/* Main Split Layout */}
          <div className="flex flex-col lg:flex-row items-center justify-center gap-8 xl:gap-12 w-full">
            {/* Left Column: Premium Gauge Visualization */}
            <div className="w-full max-w-[360px] relative flex flex-col items-center mt-6 lg:mt-0">
              {/* Modernized Gauge Labels */}
              <span className="text-[11px] font-bold tracking-wide uppercase text-red-500 absolute top-[55px] left-2 -rotate-45 sm:left-4">
                Poor
              </span>
              <span className="text-[11px] font-bold tracking-wide uppercase text-amber-500 absolute top-[-4px] left-[70px] -rotate-12 sm:left-[85px]">
                Average
              </span>
              <span className="text-[11px] font-bold tracking-wide uppercase text-orange-500 absolute top-[-4px] right-[70px] rotate-12 sm:right-[85px]">
                Good
              </span>
              <span className="text-[11px] font-bold tracking-wide uppercase text-emerald-600 absolute top-[55px] right-2 rotate-45 sm:right-4">
                Excellent
              </span>

              {/* Gauge Component Instance */}
              <GaugeChart
                id="gauge-chart1"
                nrOfLevels={4}
                percent={creditScore / maxScore}
                needleColor="#1E293B" // Slate-800
                textColor="transparent"
                needleBaseColor="#1E293B"
                arcsLength={[0.25, 0.25, 0.25, 0.25]}
                colors={["#EF4444", "#F59E0B", "#F97316", "#10B981"]} // Modern Tailwind Semantic Colors
                arcWidth={0.2}
              />

              {/* Dynamic Big Score Indicator */}
              <div className="absolute bottom-10 flex flex-col items-center justify-center">
                <span className="text-4xl font-extrabold text-slate-900 tracking-tight">
                  {creditScore}
                </span>
                <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mt-0.5">
                  CRIF Score
                </span>
              </div>
            </div>

            {/* Right Column: Structured Bureau Metrics Card */}
            <div className="flex flex-col w-full lg:max-w-md bg-slate-50/60 border border-slate-100 rounded-xl p-5 md:p-6">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-4">
                Report Summary
              </h3>

              <ul className="w-full flex flex-col space-y-3 text-sm">
                <li className="flex justify-between items-center pb-2.5 border-b border-slate-400/60 text-slate-600">
                  <span className="font-medium">Total Accounts</span>
                  <span className="font-semibold text-slate-900 bg-white border border-slate-400/80 px-2 py-0.5 rounded-md text-xs">
                    {primary["primary_number_of_accounts"] ||
                      primary["NUMBER-OF-ACCOUNTS"] ||
                      "0"}
                  </span>
                </li>
                <li className="flex justify-between items-center pb-2.5 border-b border-slate-400/60 text-slate-600">
                  <span className="font-medium">Active Accounts</span>
                  <span className="font-semibold text-emerald-600 bg-emerald-50/50 border border-emerald-100 px-2 py-0.5 rounded-md text-xs">
                    {primary["primary_active_number_of_accounts"] ||
                      primary["ACTIVE-ACCOUNTS"] ||
                      "0"}
                  </span>
                </li>
                <li className="flex justify-between items-center pb-2.5 border-b border-slate-400/60 text-slate-600">
                  <span className="font-medium">Total Balance Amount</span>
                  <span className="font-semibold text-slate-900">
                    ₹
                    {primary["primary_current_balance"] ||
                      primary["NUMBER-OF-ACCOUNTS"] ||
                      "0"}
                  </span>
                </li>
                <li className="flex justify-between items-center pb-2.5 border-b border-slate-400/60 text-slate-600">
                  <span className="font-medium">Total Past Due</span>
                  <span
                    className={`font-semibold px-2 py-0.5 rounded-md text-xs ${
                      (primary["primary_overdue_number_of_accounts"] ||
                        primary["TOTAL-AMT-OVERDUE"]) > 0
                        ? "text-red-600 bg-red-50 border border-red-100"
                        : "text-slate-500 bg-white border border-slate-400"
                    }`}
                  >
                    {primary["primary_overdue_number_of_accounts"] ||
                      primary["TOTAL-AMT-OVERDUE"] ||
                      "0"}
                  </span>
                </li>
                <li className="flex justify-between items-center pb-2.5 border-b border-slate-400/60 text-slate-600">
                  <span className="font-medium">
                    Recent Accounts{" "}
                    <span className="text-[11px] text-slate-400 font-normal">
                      (Last 6m)
                    </span>
                  </span>
                  <span className="font-semibold text-slate-800">
                    {derived["new_accounts_in_last_six_months"] || "0"}
                  </span>
                </li>
                <li className="flex justify-between items-center text-slate-600">
                  <span className="font-medium">
                    New Delinquencies{" "}
                    <span className="text-[11px] text-slate-400 font-normal">
                      (Last 6m)
                    </span>
                  </span>
                  <span
                    className={`font-semibold ${derived["NEW-DELINQ-ACCOUNT-IN-LAST-SIX-MONTHS"] > 0 ? "text-red-500 font-bold" : "text-slate-800"}`}
                  >
                    {derived["NEW-DELINQ-ACCOUNT-IN-LAST-SIX-MONTHS"] || "0"}
                  </span>
                </li>
              </ul>

              {/* Action Elements Wrapper */}
              <div className="flex items-center gap-3 mt-6 pt-2">
                <button
                  type="button"
                  onClick={() => setModalOpen(true)}
                  className="w-full inline-flex justify-center items-center px-4 py-2.5 text-sm font-semibold text-white bg-green-600 border  hover:bg-green-900 rounded-xl shadow-sm active:scale-[0.99] transition-all duration-150"
                >
                  View Full Report
                </button>
              </div>

              {/* Modal Window Integration */}
              <CrifScoreReportModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                crifV4Report={crifV4Report}
                crifV4Error={crifV4Error}
                submittedName={submittedName}
                submittedMobile={submittedMobile}
              />
            </div>
          </div>
        </div>
      ) : null}

      <div className="flex justify-center w-full mb-12">
        <div className="flex flex-col bg-white border border-slate-400/80 rounded-xl shadow-sm md:w-3/4 w-full p-6 md:p-8">
          {/* Clean Category Badge */}
          <div className="mb-3">
            <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold uppercase tracking-wider bg-green-100 text-green-600">
              Instructions
            </span>
          </div>

          {/* Elegant Header */}
          <h2 className="text-lg font-bold text-slate-900 tracking-tight mb-5">
            How to get the Best Financial Credit Report in CRIF?
          </h2>

          {/* Clean, Spaced List */}
          <ol className="list-decimal list-outside pl-5 space-y-3.5 text-sm text-slate-600 leading-relaxed">
            <li>
              Enter the correct customer’s{" "}
              <span className="font-medium text-slate-900">First Name</span> and{" "}
              <span className="font-medium text-slate-900">Last Name</span>.
            </li>
            <li>
              Enter the{" "}
              <span className="font-medium text-slate-900">Mobile Number</span>{" "}
              which is registered with the credit bureau company.
            </li>
            <li>
              Enter the correct{" "}
              <span className="font-medium text-slate-900">PAN Number</span>.
            </li>
            <li>
              The CRIF Credit Report only provides a detailed report of the
              consumer if their record is currently available in the CRIF
              Bureau.
            </li>
            <li>
              If you didn’t get the report, verify the submission details or
              attempt to pull records from an alternative bureau company.
            </li>
          </ol>
        </div>
      </div>
    </>
  );
};

export default CrifCreditScore4;

const MobileDataModal = ({
  mobileResponseData,
  onClose,
  setAfterVerifyMobPan,
  setAfterVerifyMobAadhaar,
  setAfterMobName,
  VerifyContinue,
}) => {
  const rootData = mobileResponseData?.data || {};

  setAfterMobName(rootData?.name);
  setAfterVerifyMobPan(rootData?.pan);
  setAfterVerifyMobAadhaar(rootData?.aadhaar || "");

  const addresses = rootData?.address || [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-3 rounded-lg shadow-2xl w-[90%] max-w-3xl max-h-[95vh] overflow-y-auto space-y-1">
        <div className="flex justify-between">
          <h2 className="text-2xl font-bold text-blue-700 border-b">
            Consumer Verification Details
          </h2>
          <button
            onClick={onClose}
            className="text-2xl text-red-600 hover:text-red-800"
          >
            ❌
          </button>
        </div>

        {rootData?.name && (
          <div className="w-full flex flex-col items-center mb-2">
            <h3 className="text-xl text-green-600 font-semibold text-center">
              Found In Experian
            </h3>
            <Link
              to="/ExperianScore2"
              className="flex items-center bg-green-700 hover:bg-green-800 text-white font-semibold py-2 px-4 gap-2 rounded transition duration-300 text-sm sm:text-base"
            >
              Result Found in Experian, Check Credit details in Experian for
              better result
              <FaHandPointLeft className="text-lg" />
            </Link>
          </div>
        )}

        {rootData?.idspay_message && (
          <div
            className={`flex justify-center border-2 p-3 rounded-lg ${
              rootData.idspay_message === "success"
                ? "bg-green-100 border-green-300"
                : "bg-red-100 border-red-300"
            }`}
          >
            <p
              className={`text-md font-serif ${
                rootData.idspay_message === "success"
                  ? "text-green-600"
                  : "text-red-500"
              }`}
            >
              {rootData.idspay_message}
            </p>
          </div>
        )}

        {/* Personal Info */}
        <div className="bg-blue-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-blue-600 mb-1">
            Personal Info
          </h3>
          <div className="grid grid-cols-2 gap-1 text-sm">
            <p>
              <strong>Full Name:</strong> {rootData?.name || "N/A"}
            </p>

            <p>
              <strong>DOB:</strong> {rootData?.dob || "N/A"}
            </p>
            <p>
              <strong>Gender:</strong> {rootData?.gender || "N/A"}
            </p>
            <p>
              <strong>PAN:</strong> {rootData?.pan || "N/A"}
            </p>
            <p>
              <strong>Email:</strong> {rootData?.email || "N/A"}
            </p>
          </div>
        </div>

        {/* Addresses */}
        <div className="bg-yellow-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-yellow-600 mb-2">
            Addresses
          </h3>
          {addresses.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-sm border border-gray-300 rounded-md">
                <thead className="bg-yellow-100 text-gray-700">
                  <tr>
                    <th className="border px-2 py-1 text-left">Address #</th>
                    <th className="border px-2 py-1 text-left">Full Address</th>
                    <th className="border px-2 py-1 text-left">State</th>
                    <th className="border px-2 py-1 text-left">Postal Code</th>
                  </tr>
                </thead>
                <tbody>
                  {addresses.map((address, index) => (
                    <tr key={index} className="border-t">
                      <td className="border px-2 py-1">Address {index + 1}</td>
                      <td className="border px-2 py-1">
                        {[
                          address.first_line_of_address,
                          address.second_line_of_address,
                          address.third_line_of_address,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </td>
                      <td className="border px-2 py-1">
                        {address.state || "N/A"}
                      </td>
                      <td className="border px-2 py-1">
                        {address.postal_code || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-sm">No address information available.</p>
          )}
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-center gap-3 mt-3">
          <button
            onClick={VerifyContinue}
            className="bg-green-500 text-white px-4 py-1 rounded-md hover:bg-green-600 transition"
          >
            Verify & Continue
          </button>
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-1 rounded-md hover:bg-red-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
